import React, { useEffect, useState } from 'react';
import { db } from '../../view/shared/utilities/cache';
import { useSelector } from 'react-redux';
import styles from './FailedRequestsBanner.module.css';
import CustomModal from './Modal';
import { Trans } from '@lingui/react';

const FailedRequestsBanner = () => {
  const [failedRequests, setFailedRequests] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const currentUserId = useSelector(state => state.user?.id);

  useEffect(() => {
    if (!currentUserId) return;

    const fetchFailedRequests = async () => {
      try {
        const requests = await db.table('offlineRequests')
          .where('[userId+status]').equals([currentUserId, 'permanent_error'])
          .or('[userId+status]').equals([currentUserId, 'decryption_failed'])
          .or('[userId+status]').equals([currentUserId, 'error'])
          .toArray();
        setFailedRequests(requests);
      } catch (error) {
        console.error("Failed to fetch permanently failed requests:", error);
      }
    };

    const interval = setInterval(fetchFailedRequests, 5000); // Poll for failed requests every 5 seconds
    fetchFailedRequests(); // Initial fetch

    return () => clearInterval(interval);
  }, [currentUserId]);

  const handleRetry = async (cacheId) => {
    try {
      await db.table('offlineRequests').update(cacheId, {
        status: 'pending',
        attempts: 0, // Reset attempts
      });
    } catch (error) {
      console.error("Failed to retry request:", error);
    }
  };

  const handleRemove = async (cacheId) => {
    try {
      await db.table('offlineRequests').delete(cacheId);
    } catch (error) {
      console.error("Failed to remove request:", error);
    }
  };

  if (failedRequests.length === 0) {
    return null;
  }

  return (
    <>
      <div className={styles.banner} onClick={() => setModalOpen(true)}>
        <p>You have {failedRequests.length} operation(s) that failed to sync. Click to view.</p>
      </div>
      <CustomModal
        modalHeader={<Trans id="failed_requests">Failed Sync Operations</Trans>}
        isOpen={isModalOpen}
        toggle={() => setModalOpen(!isModalOpen)}
        bodyContent={
          <div className={styles.modalBody}>
            {failedRequests.map(req => (
              <div key={req.cacheId} className={styles.requestItem}>
                <p><strong>Type:</strong> {req.entityType}</p>
                <p><strong>Status:</strong> {req.status}</p>
                <p><strong>Error:</strong> {req.lastAttemptError}</p>
                <button onClick={() => handleRetry(req.cacheId)} className={`btn btn-primary ${styles.button}`}>Retry</button>
                <button onClick={() => handleRemove(req.cacheId)} className={`btn btn-danger ${styles.button}`}>Remove</button>
              </div>
            ))}
          </div>
        }
        footerContent={
          <button onClick={() => setModalOpen(false)} className="btn btn-light">
            <Trans id="close">Close</Trans>
          </button>
        }
      />
    </>
  );
};

export default FailedRequestsBanner;
